// extracted by mini-css-extract-plugin
export default {"colors":"\"../../../styles/colors.module.css\"","cinnabar":"#DD4533","container":"Slide_container__3tAQ0"};